
<template>
  <div class="inner-block" id="template-block">
    <div class="vue-tempalte" id="form-data">
      <form @submit.prevent="login">
        <h3>Sign In</h3>

        <div class="form-group">
          <label>Email address</label>
          <input type="email" id="email" class="form-control form-control-lg" v-model="email"/>
        </div>

        <div class="form-group">
          <label>Password</label>
          <input type="password" id="password" class="form-control form-control-lg" v-model="password"/>
        </div>

        <button type="submit" id="post-submit" class="btn btn-dark btn-lg btn-block mt-2">Sign In</button>

      </form>

    </div>
  </div>
</template>
<style>

.inner-block {
  width: 370px;
  margin: auto;
  background: #ffffff;
  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);
  padding: 40px 55px 45px 55px;
  border-radius: 15px;
  transition: all .3s;
}

.vertical-center h3 {
  text-align: center;
  margin: 0;
  line-height: 1;
  padding-bottom: 20px;
}
label {
  font-weight: 500;
}

</style>
<script>


import {AUTH_REQUEST} from "@/store/actions/auth";


export default {
  name: 'form-data',
  data() {
    return {
      email: '',
      password: '',
    }
  },
  methods: {
    login: function () {
      const {email, password} = this;
      this.$store.dispatch(AUTH_REQUEST, {email, password})
          .then(() => {
                if (localStorage.getItem("users-role") === "admin") {
                  this.$router.push({name: "users"});
                } else {
                  this.$router.push({name:"jobs"});
                }
              }
          );
    }
  }
};
</script>
